import React, { createContext, useMemo, useState } from "react";

interface SelectedImageContextData {
    selectedImageFile: File | null;
    chatAttachment: File | null
    selectedFriendImg: File | null
    setSelectedImageFile: (image: File) => void;
    setAttachmentFile: (image: File | null) => void;
    setSelectedFriendImg: (image: File | null) => void;
}

export const SelectedImageContext = createContext<SelectedImageContextData>({
    selectedImageFile: null,
    chatAttachment: null,
    selectedFriendImg: null,
    setSelectedImageFile: () => { },
    setAttachmentFile: () => { },
    setSelectedFriendImg: () => { }
});

export const SelectedImageFileProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {

    const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
    const [chatAttachment, setAttachmentFile] = useState<File | null>(null);
    const [selectedFriendImg, setSelectedFriendImg] = useState<File | null>(null);

    const value = useMemo(() => ({
        selectedImageFile, chatAttachment, selectedFriendImg, setSelectedImageFile, setAttachmentFile,
        setSelectedFriendImg
    }), [selectedImageFile, chatAttachment, selectedFriendImg]);

    return (
        <SelectedImageContext.Provider value={value}>
            {children}
        </SelectedImageContext.Provider>
    );
};